import React from 'react';
import { string, any } from 'prop-types';
import { FlexContainer } from '../../layouts/Wrapper/Base.components';
import { Row, Column } from '../Grid';
import Icon from '../Icon';
import Text from '../Text';
import MobileAcordion from '../MobileAcordion';
import { ANDROID_GREEN, APPLE_GREEN, WHITE } from '../../../utils/colors';

const MobileFilterWrapper = ({ title, children }) => {
    return (
        <FlexContainer
            direction='column'
        >
            <Row pB={12}>
                <Text text={title} strong size={16} />
            </Row>
            <MobileAcordion
                backgroundColorOpened={APPLE_GREEN}
                backgroundColorClosed={ANDROID_GREEN}
                arrowColor={WHITE}
                left={
                    <Column direction='row' align='center'>
                        <Icon name='filters' color='#FFFFFF' size={16} right={10} />
                        <Text text='Filtrar por:' strong color='#FFFFFF' size={14} />
                    </Column>
                }
            >
                { children }
            </MobileAcordion>
        </FlexContainer>
    );
};

MobileFilterWrapper.propTypes = {
    title: string,
    children: any
};

MobileFilterWrapper.defaultProps = {
    title: '',
    children: null
};

export default MobileFilterWrapper;
